export default __webpack_public_path__ + "img/22e741a562fa55e36e5a52bd9a12a899.svg";